import { render, staticRenderFns } from "./AccountRemittance.vue?vue&type=template&id=18be612d&scoped=true&"
import script from "./AccountRemittance.vue?vue&type=script&lang=js&"
export * from "./AccountRemittance.vue?vue&type=script&lang=js&"
import style0 from "./AccountRemittance.vue?vue&type=style&index=0&id=18be612d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be612d",
  null
  
)

export default component.exports